<template>
    <div>

        <h4 class="mb-6">{{$t("RegistrationTerminals")}}</h4>

        <vs-button color="success" type="border" icon-pack="feather" icon="icon-plus-circle" class="mb-6" @click="addTerminalPrompt = true">{{$t('Add')}}</vs-button>

        <div class="vx-row">
            <div :key="item.id" class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full mb-6" v-for="item in terminals">
                <vx-card>
                    <div class="pt-2">
                        <div class="flex justify-around">
                            <monitor-icon :size="'100'" :style="{color: (item.online) ? '#28C76F' : '#EA5455'}" class="mb-6"/>
                        </div>
                        <div class="flex justify-around">
                            <h1 class="p-6" :style="{color: (item.online) ? '#28C76F' : '#EA5455'}">{{item.name}}</h1>
                        </div>

                        <vs-divider/>

                        <vs-button style="float: left" color="warning" class="mt-6; mr-3" @click="openTerminalEdit(item.id, item.name)" icon-pack="feather" icon="icon-edit">{{$t("Edit")}}</vs-button>
                        <vs-button style="float: left" color="#7367F0" class="mt-6; mr-3" @click="getTerminalLink(item.link)" icon-pack="feather" icon="icon-clipboard"/>
                        <vs-button style="float: right" color="danger" class="mt-6; mr-3" @click="removeTerminal(item.id)" icon-pack="feather" icon="icon-trash-2"/>
                        <div style="clear: both"></div>

                    </div>
                </vx-card>
            </div>
        </div>

        <vs-popup :title="$t('Add')" :active.sync="addTerminalPrompt">
            <div id="addTerminalDiv" class="vs-con-loading__container" >
                <p class="mt-6">Name</p>
                <vs-input v-model="addName" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addTerminal">{{$t('Add')}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="editTerminalPrompt">
            <div id="editTerminalDiv" class="vs-con-loading__container" >
                <p class="mt-6">Name</p>
                <vs-input v-model="editName" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="editTerminal">{{$t('Save')}}</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>

    import MonitorIcon from 'vue-feather-icons/icons/MonitorIcon'

    export default {
        components: {
            MonitorIcon
        },
        data(){
            return {
                terminals: [],

                addTerminalPrompt: false,
                addName: "",

                editTerminalPrompt: false,
                editName: "",
                editId: 0
            }
        },
        methods: {
            openTerminalEdit(id, name){
                this.editName = name;
                this.editId = id;
                this.editTerminalPrompt = true;
            },
            loadData(){
                const thisIns = this;
                const loadPromise = this.$http.get('/api/v1/registration_terminal/');
                loadPromise.then(function (response) {
                    thisIns.terminals = response.data;
                }).catch(function (error) {
                    thisIns.$printError(error);
                });

            },
            addTerminal(){

                this.$vs.loading({
                    container: "#addTerminalDiv",
                    type: 'corners',
                    scale: 0.7
                });
                const thisIns = this;
                const addPromise = this.$http.post('/api/v1/registration_terminal/', {
                    name: this.addName,
                });
                addPromise.then(function () {
                    thisIns.addTerminalPrompt = false;
                    thisIns.loadData()
                }).catch(function (error) {
                    thisIns.$printError(error);
                }).finally(function () {
                    thisIns.$vs.loading.close("#addTerminalDiv > .con-vs-loading");
                })

            },
            editTerminal(){

                this.$vs.loading({
                    container: "#editTerminalDiv",
                    type: 'corners',
                    scale: 0.7
                });
                const thisIns = this;
                const addPromise = this.$http.put('/api/v1/registration_terminal/' + this.editId, {
                    name: this.editName,
                });
                addPromise.then(function () {
                    thisIns.editTerminalPrompt = false;
                    thisIns.loadData()
                }).catch(function (error) {
                    thisIns.$printError(error);
                }).finally(function () {
                    thisIns.$vs.loading.close("#editTerminalDiv > .con-vs-loading");
                })

            },
            removeTerminal(id){
                const thisIns = this;
                const loadPromise = this.$http.delete('/api/v1/registration_terminal/' + id);
                loadPromise.then(function () {
                    thisIns.loadData();
                }).catch(function (error) {
                    thisIns.$printError(error);
                });
            },
            getTerminalLink(link){
                const thisIns = this;
                thisIns.$copyText(link).then(function() {
                    thisIns.$printSuccess(thisIns.$t("LinkCopied"));
                }, function() {
                    alert(link);
                })
            }
        },
        mounted() {

            this.loadData()

        },
        beforeRouteLeave (to, from, next) {
            if(this.addTerminalPrompt){
                this.addTerminalPrompt = false;
                next(false)
            }else{
                next()
            }
        },

    }

</script>
